'use client'
import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { Dropdown, Flex } from 'antd'
import styles from './style.module.scss'
import { useGetV2AccountOverviewQuery } from 'core/query/yapi/hk-web/Hotcoin/query'
import { useAppSetting } from '@/components/appStore'
import useUtils from 'core/utils/useUtils'
import cls from 'classnames'
import { useLocale } from 'core/components/Locale'
import { useHCRouter } from '@/components/HCNextLink'
import { useLocalStorageState } from 'ahooks'
import { spliceDecimal } from 'core/utils'
import { useTransfer } from '@/hooks/useTransfer'
import { useAuthenticate } from 'core/components/Authenticate'
import { useResponsiveDevice } from '@/hooks/useResponsiveDevice'

type TProps = {
  visible: boolean
}

const AssetsOverview = (props: TProps, ref: any) => {
  const user = useAuthenticate()
  const responsiveDevice = useResponsiveDevice()
  const { data: accountOverviewData, refetch } = useGetV2AccountOverviewQuery(
    {},
    { staleTime: 0, enabled: !!user?.loginData && props.visible }
  )

  useImperativeHandle(ref, () => {
    return {
      refetch,
    }
  }, [refetch])

  const currencyCode = useAppSetting('currencyCode')
  const assetsUnit = ['USDT', 'BTC', 'ETH', currencyCode]
  const t = useLocale()
  const router = useHCRouter()
  const handleNavigation = (item: any) => {
    if (item.meta?.auth) {
      router.push(`login`)
      return
    }
    router.push(item.link)
  }

  const { rateFilter } = useUtils()
  const [openKeys, setOpenKeys] = useState(false)
  const handleVisibleChange = (open: boolean) => {
    if (open) {
      setOpenKeys(true)
    } else {
      setOpenKeys(false)
    }
  }

  const [encryption, setEncryption] = useLocalStorageState<boolean>('encryption', {
    defaultValue: false,
  })

  const [USER_AssetsUnit, setUserAssetsUnit] = useLocalStorageState<number>('USER_AssetsUnit', {
    defaultValue: 1,
  })

  const assetsConvert = rateFilter(accountOverviewData?.data?.data?.totalCny)

  const currentAssetUnit = assetsUnit[(USER_AssetsUnit ?? 1) - 1]
  let totalAssets
  switch (currentAssetUnit) {
    case 'USDT':
      totalAssets = accountOverviewData?.data?.data?.totalUsdt
      break
    case 'BTC':
      totalAssets = spliceDecimal(accountOverviewData?.data?.data?.totalBtc, 2)
      break
    case 'ETH':
      totalAssets = spliceDecimal(accountOverviewData?.data?.data?.totalEth, 2)
      break
    default:
      totalAssets = assetsConvert
  }

  const handleList = [
    {
      label: '充值',
      locale: 'coinTrade_asset_019',
      icon: 'iconchongzhi',
      key: 'overView',
      link: '/assetManagement/topup',
    },
    {
      label: '提现',
      locale: 'accountCoinTrade_003',
      icon: 'icontixian',
      key: 'overView',
      link: '/assetManagement/extract',
    },
    {
      label: '划转',
      locale: 'accountCoinTrade_002',
      icon: 'iconhuazhuan1',
      key: 'transfer',
    },
  ]

  const transfer = useTransfer({
    onSuccess: (info) => {
      console.log('dialog', info)
    },
  })

  const handleItem = (item) => {
    if (item.key === 'transfer') {
      // phone响应式跳转H5划转页面
      if (responsiveDevice === 'phone') {
        router.push('/account/transfer?source=2&target=5')
        return
      }

      transfer({
        // config
        source: 2,
        target: 5,
      }).then((res) => {
        console.log('dialog then', res)
      })
    } else {
      handleNavigation(item)
    }
  }

  return (
    <div className={styles.assetsOverview}>
      <div className={styles.header}>
        <div className={styles.title}>
          <div className={styles.titleLeft}>
            <span>{t('contractOpen_assetIndex_003')}</span>
            <span
              onClick={() => setEncryption(!encryption)}
              className={cls(!encryption && styles.isShow, styles.showItem)}
            ></span>
          </div>
          <div
            className={styles.linkButton}
            onClick={() => {
              // phone响应式跳转H5页面
              if (responsiveDevice === 'phone') {
                router.push('/account/capital/overview')
                return
              }

              handleNavigation({
                key: 'overView',
                link: '/assetManagement/overView',
              })
            }}
          >
            {t('header_089')}
            <i></i>
          </div>
        </div>
        <div className={styles.num}>
          <Flex align="center">
            {' '}
            <div className={styles.textOverflow}>{!encryption ? totalAssets : '******'}</div>
          </Flex>

          <Dropdown
            menu={{
              items: assetsUnit.map((i) => ({
                key: i,
                label: i,
                type: 'submenu',
              })),
              selectable: true,
              defaultSelectedKeys: [currentAssetUnit],
              onClick: ({ key }) => {
                // setCurrentAssetUnit(key)
                setUserAssetsUnit(assetsUnit.indexOf(key) + 1)
              },
            }}
            onOpenChange={(open) => handleVisibleChange(open)}
          >
            <div className={styles.iconBox}>
              <span>{!encryption ? currentAssetUnit : ''}</span>
              <i style={{ transform: openKeys ? 'rotate(180deg)' : 'rotate(0deg)' }}></i>
            </div>
          </Dropdown>
        </div>
        <div className={styles.title}>
          ≈ {!encryption ? assetsConvert : '******'} {!encryption ? currencyCode : ''}
        </div>
      </div>

      <div className={cls(styles.content, 'show-pc')}>
        <div className={styles.contentItemBox}>
          {handleList.map((item, index) => (
            <div className={styles.contentItem} key={index} onClick={() => handleItem(item)}>
              <div className={styles.iconBox}>
                <i className={cls('iconfont f26', item.icon)}></i>
              </div>
              <div className={styles.contentItemLabel}>{t(item.locale)}</div>
            </div>
          ))}
        </div>
      </div>

      <div className={cls(styles.buttons, 'hide-pc')}>
        {handleList.map((item, index) => (
          <button key={index} onClick={() => handleItem(item)}>
            {t(item.locale)}
          </button>
        ))}
      </div>
    </div>
  )
}

export default forwardRef(AssetsOverview)
